import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';

export class CarModel {
  carForm = new UntypedFormGroup({
    'text': new UntypedFormControl('', [
      Validators.required,
    ]),
    'green': new UntypedFormControl(''),
    'id': new UntypedFormControl(''),
    'description': new UntypedFormControl(''),
    'make': new UntypedFormControl(''),
    'makeSlug': new UntypedFormControl(''),
    'model': new UntypedFormControl(''),
    'modelSlug': new UntypedFormControl(''),
    'year': new UntypedFormControl(''),
    'class': new UntypedFormControl('')
  });
}
